import ApplicationController from "application_controller.js";
import * as easepick from "@gothassos/easepick-bundle";
window.easepick = easepick; //* fixes issues loading plugins

//* Display-only availability calendar for a whole-property site. It reads the
//* booked stays from the availability endpoint and marks the booked nights. A
//* stay is [arrival, departure): the departure day is free for the next
//* arrival. Days are not clickable, only month navigation works. The element
//* stays hidden until the booked stays are read, so a visitor never sees a
//* calendar that wrongly shows every night as free.
//*
//* <div hidden
//*      data-controller="availability-calendar"
//*      data-availability-calendar-url-value="/availability"
//*      data-availability-calendar-locale-value="en"
//*      data-availability-calendar-css-value="/assets/.../easepick_availability.css">
//*   <input type="text" class="d-none" data-availability-calendar-target="calendar">
//* </div>
export default class extends ApplicationController {
  debug = false;

  static targets = ["calendar"];

  static values = {
    url: String,
    locale: { type: String, default: "en-US" },
    css: { type: String, default: "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.0/dist/index.css" },
  };

  async connect() {
    this.log_function("connect");

    this.stays = await this._fetchStays();
    if (!this.stays || !this.element.isConnected) return;

    const today = new easepick.DateTime();
    const lastDay = new easepick.DateTime(new Date(today.getFullYear() + 1, 11, 31));

    this.instance = new easepick.create({
      lang: this.currentLocale,
      element: this.calendarTarget,
      inline: true,
      firstDay: 1,
      translate: false,
      plugins: ["LockPlugin"],
      //* Bounds the navigation to the end of next year.
      LockPlugin: {
        minDate: today,
        maxDate: lastDay,
      },
      css: [this.cssValue],
      setup: (picker) => {
        picker.on("view", (evt) => this._decorate(evt));
      },
    });

    this.element.hidden = false;
  }

  disconnect() {
    this.log_function("disconnect");

    if (this.instance) this.instance.destroy();
    this.instance = null;
  }

  //* Returns the booked stays as [arrival, departure] DateTime pairs, or null
  //* when the endpoint does not answer.
  async _fetchStays() {
    this.log_function("_fetchStays");

    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } });
      if (!response.ok) return null;

      const { booked } = await response.json();
      return booked.map(([arrival, departure]) => [
        new easepick.DateTime(arrival, "YYYY-MM-DD"),
        new easepick.DateTime(departure, "YYYY-MM-DD"),
      ]);
    } catch {
      return null;
    }
  }

  //* Marks the booked nights. Also marks the first booked night of a stay
  //* (stay-start, still free for a check-out) and the day after the last
  //* booked night (stay-end, free for a check-in), so the stylesheet can
  //* colour half of those days. A changeover day between two stays stays booked.
  _decorate(evt) {
    if (evt.detail.view !== "CalendarDay") return;

    const { target, date } = evt.detail;
    const booked = date.inArray(this.stays, "[)");
    const bookedBefore = date.clone().subtract(1, "day").inArray(this.stays, "[)");
    target.classList.toggle("booked", booked);
    target.classList.toggle("stay-start", booked && !bookedBefore);
    target.classList.toggle("stay-end", !booked && bookedBefore);
  }

  get currentLocale() {
    switch (this.localeValue) {
      case "en":
        return "en-US";
      case "el":
        return "el-GR";
      default:
        return "en-US";
    }
  }
}
